var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlert = function SvgAlert(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4.497 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e73c5b",
    d: "M.003 17.712a2.23 2.23 0 0 1 2.266-2.288 2.289 2.289 0 0 1 0 4.576 2.23 2.23 0 0 1-2.266-2.288m.6-14.369L.515 0h3.506l-.118 3.343-.484 10H1.09Z",
    "data-name": "Pfad 385"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlert);
export default ForwardRef;